var _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _ellipse, _ellipse2, _ellipse3, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: "100%",
    height: 500,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101,130.42a1,1,0,0,1-.52-.15l-1.28-.78a1,1,0,0,1-.33-1.37,1,1,0,0,1,1.37-.34l1.28.78a1,1,0,0,1,.34,1.38A1,1,0,0,1,101,130.42Z",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.07,185.18a1,1,0,0,1-.52-.14l-2.6-1.58a1,1,0,0,1-.33-1.38,1,1,0,0,1,1.37-.33l2.6,1.58a1,1,0,0,1,.33,1.37A1,1,0,0,1,191.07,185.18Zm-11.26-6.84a1,1,0,0,1-.52-.15l-2.6-1.58a1,1,0,0,1-.33-1.37,1,1,0,0,1,1.37-.34l2.6,1.58a1,1,0,0,1,.33,1.38A1,1,0,0,1,179.81,178.34Zm-11.26-6.85a1.07,1.07,0,0,1-.52-.14l-2.6-1.58a1,1,0,0,1-.33-1.38,1,1,0,0,1,1.37-.33l2.6,1.58a1,1,0,0,1-.52,1.85Zm-11.26-6.84a1,1,0,0,1-.52-.15l-2.6-1.58a1,1,0,1,1,1-1.71l2.6,1.58a1,1,0,0,1-.52,1.86ZM146,157.8a1,1,0,0,1-.52-.15l-2.6-1.58a1,1,0,1,1,1-1.7l2.6,1.58a1,1,0,0,1-.52,1.85ZM134.76,151a1,1,0,0,1-.51-.14l-2.6-1.58a1,1,0,1,1,1-1.71l2.59,1.58a1,1,0,0,1,.34,1.37A1,1,0,0,1,134.76,151Zm-11.26-6.84A1,1,0,0,1,123,144l-2.59-1.58a1,1,0,0,1-.34-1.37,1,1,0,0,1,1.38-.34l2.59,1.58a1,1,0,0,1-.52,1.86Zm-11.26-6.85a1,1,0,0,1-.52-.14l-2.59-1.58a1,1,0,1,1,1-1.71l2.6,1.58a1,1,0,0,1-.52,1.85Z",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M201,191.23a.92.92,0,0,1-.51-.15l-1.29-.78a1,1,0,0,1-.33-1.37,1,1,0,0,1,1.37-.34l.75.46.73-.48a1,1,0,0,1,1.09,1.68l-1.26.82A1.1,1.1,0,0,1,201,191.23Z",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.4,185.15a1,1,0,0,1-.54-1.84l2.43-1.57a1,1,0,1,1,1.09,1.68L210.94,185A1,1,0,0,1,210.4,185.15ZM221,178.32a1,1,0,0,1-.55-1.84l2.44-1.58a1,1,0,0,1,1.09,1.68l-2.44,1.58A1.09,1.09,0,0,1,221,178.32Zm10.56-6.84a1,1,0,0,1-.84-.46,1,1,0,0,1,.29-1.38l2.44-1.58a1,1,0,1,1,1.09,1.68l-2.44,1.58A1,1,0,0,1,231.53,171.48Zm10.56-6.84a1,1,0,0,1-.54-1.84l2.44-1.58a1,1,0,0,1,1.08,1.68l-2.43,1.58A1,1,0,0,1,242.09,164.64Zm10.57-6.84a1,1,0,0,1-.55-1.84l2.44-1.57a1,1,0,0,1,1.09,1.67l-2.44,1.58A1,1,0,0,1,252.66,157.8ZM263.22,151a1,1,0,0,1-.54-1.84l2.43-1.58a1,1,0,1,1,1.09,1.68l-2.44,1.58A1,1,0,0,1,263.22,151Zm10.57-6.84a1,1,0,0,1-.84-.46,1,1,0,0,1,.29-1.38l2.44-1.58a1,1,0,0,1,1.09,1.68L274.33,144A1,1,0,0,1,273.79,144.13Zm10.56-6.84a1,1,0,0,1-.54-1.84l2.43-1.58a1,1,0,1,1,1.09,1.68l-2.44,1.58A1,1,0,0,1,284.35,137.29Z",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.91,130.45a1,1,0,0,1-.54-1.84l1.26-.81a1,1,0,0,1,1.09,1.68l-1.26.81A1,1,0,0,1,294.91,130.45Z",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "248.16 183.8 199.89 155.93 151.61 183.8 117.68 183.8 117.68 203.39 199.89 250.86 282.1 203.39 282.1 183.8 248.16 183.8",
    fill: "#ffd200"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "248.16 183.8 199.89 155.93 151.61 183.8 117.68 183.8 117.68 203.39 199.89 250.86 282.1 203.39 282.1 183.8 248.16 183.8",
    fill: "#fff",
    opacity: 0.44
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "117.68 183.8 199.89 231.27 282.1 183.8 199.89 136.34 117.68 183.8",
    fill: "#ffd200"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.31 124.35 296.17 112.72 276.03 124.35 261.88 124.35 261.88 132.52 296.17 152.32 330.47 132.52 330.47 124.35 316.31 124.35",
    fill: "#24285b"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.31 124.35 296.17 112.72 276.03 124.35 261.88 124.35 261.88 132.52 296.17 152.32 330.47 132.52 330.47 124.35 316.31 124.35",
    fill: "#fff",
    opacity: 0.22
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "261.88 124.35 296.17 144.15 330.47 124.35 296.17 104.55 261.88 124.35",
    fill: "#24285b"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.84 124.35 99.7 112.72 79.56 124.35 65.4 124.35 65.4 132.52 99.7 152.32 134 132.52 134 124.35 119.84 124.35",
    fill: "#24285b"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "119.84 124.35 99.7 112.72 79.56 124.35 65.4 124.35 65.4 132.52 99.7 152.32 134 132.52 134 124.35 119.84 124.35",
    fill: "#fff",
    opacity: 0.22
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "65.4 124.35 99.7 144.15 134 124.35 99.7 104.55 65.4 124.35",
    fill: "#24285b"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.99,
    cy: 185.3,
    rx: 31.7,
    ry: 20.56,
    opacity: 0.09
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.17,
    cy: 123.59,
    rx: 14.6,
    ry: 9.47,
    opacity: 0.09
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.49,
    cy: 123.59,
    rx: 14.6,
    ry: 9.47,
    opacity: 0.09
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.73 120.04 197.99 96.42 245.25 120.04 197.99 153.66 150.73 120.04",
    fill: "#24285b"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.73 109.86 197.99 139.26 197.99 46.08 150.73 109.86",
    fill: "#feb019"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "245.25 109.86 197.99 139.26 197.99 46.08 245.25 109.86",
    fill: "#feb019"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "245.25 109.86 197.99 139.26 197.99 46.08 245.25 109.86",
    fill: "#fff",
    opacity: 0.44
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.73 120.04 197.99 153.66 197.99 185.94 150.73 120.04",
    fill: "#feb019"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "245.25 120.04 197.99 153.66 197.99 185.94 245.25 120.04",
    fill: "#feb019"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "245.25 120.04 197.99 153.66 197.99 185.94 245.25 120.04",
    fill: "#fff",
    opacity: 0.44
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "272.6 91.2 296.59 79.2 320.58 91.2 296.59 108.27 272.6 91.2",
    fill: "#24285b"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "272.6 86.03 296.59 100.95 296.59 53.65 272.6 86.03",
    fill: "#feb019"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.58 86.03 296.59 100.95 296.59 53.65 320.58 86.03",
    fill: "#feb019"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.58 86.03 296.59 100.95 296.59 53.65 320.58 86.03",
    fill: "#fff",
    opacity: 0.44
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "272.6 91.2 296.59 108.27 296.59 124.65 272.6 91.2",
    fill: "#feb019"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.58 91.2 296.59 108.27 296.59 124.65 320.58 91.2",
    fill: "#feb019"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.58 91.2 296.59 108.27 296.59 124.65 320.58 91.2",
    fill: "#fff",
    opacity: 0.44
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.71 91.2 99.7 79.2 123.69 91.2 99.7 108.27 75.71 91.2",
    fill: "#24285b"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.71 86.03 99.7 100.95 99.7 53.65 75.71 86.03",
    fill: "#feb019"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.69 86.03 99.7 100.95 99.7 53.65 123.69 86.03",
    fill: "#feb019"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.69 86.03 99.7 100.95 99.7 53.65 123.69 86.03",
    fill: "#fff",
    opacity: 0.44
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "75.71 91.2 99.7 108.27 99.7 124.65 75.71 91.2",
    fill: "#feb019"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.69 91.2 99.7 108.27 99.7 124.65 123.69 91.2",
    fill: "#feb019"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "123.69 91.2 99.7 108.27 99.7 124.65 123.69 91.2",
    fill: "#fff",
    opacity: 0.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.c5ae1e1fcf38c6041861f0d1aed1e15e.svg";
export { ForwardRef as ReactComponent };